import 'reset-css/reset.css';
import "selectra/src/scss/index.scss";
import '../scss/site.scss';

import { App } from './Lib';

const app = new App();

app.init();
